var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "url(#pattern0_1154_664)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_1154_664",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1154_664",
    transform: "scale(0.0454545)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1154_664",
    width: 22,
    height: 22,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyBpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMC1jMDYwIDYxLjEzNDc3NywgMjAxMC8wMi8xMi0xNzozMjowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNSBXaW5kb3dzIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjdGMDhFODAyMEQ1MjExRjE5OTIyRDUwM0EyMEIwQkFBIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjdGMDhFODAzMEQ1MjExRjE5OTIyRDUwM0EyMEIwQkFBIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6N0YwOEU4MDAwRDUyMTFGMTk5MjJENTAzQTIwQjBCQUEiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6N0YwOEU4MDEwRDUyMTFGMTk5MjJENTAzQTIwQjBCQUEiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz7ne1QGAAABoklEQVR42qyUTyhEURSHZ64RYkHZkFhMIWxRFspWWShEyZaFGpQFxoKsRclGKQs2aiLTSLLyJ5spSUqyUCysCLMS47t1pq7nzcybN+/UN7955573e2fu3PP8yWTS52UEV2NVyKfy2DSIXMGI36uOMa1EzqAYmgMemZYg+9AAPQ+h7oTywLQA2YYO2MU0qvNe7PEK9MI7TKaSKs9uZ5FxuQzT7XPexpgOIUtyGYd1c93VqcC0CzmEIviGdrqNmzXKhWkLEhFTHWtWUx0BCv3oIvTDtf4DzL2ymNYiR1AuqSeYt6tVYhiWM6i/n2PQaGNaIT+/2kiHaOIjnXG9JVcHpxi1GaZ6mvagyaiLYhpJt2UB2a85GcVU6PE8wbAPPYYt6DTWE8Yxsw3FU2/RMZu1MjiASxiwrC1w32NGY/1Bke5o2Wa9EFotuRuZNl9WY4lpiGWp/4FRGvlybEyxvmkY7jPUb1B34eS8/xkQbnrVrz14s6l9gRmng/Rv8jC/QwZlVM2Ykge7MxZzPV0ThvkmuZ1cRj/jS4hzXIOUyq/IKX4FGAAhAYRKTWcDBQAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick3);
export default __webpack_public_path__ + "static/media/tick 3.d474a5d3a99ac030dfc3ae426aee72f2.svg";
export { ForwardRef as ReactComponent };